export default {
    circle: `<circle id="Oval" cx="250" cy="200" r="150" stroke="#787878" stroke-width="5" fill="none" />`,
    rect: `<rect width="200" height="200" x="150" y="100" stroke="#787878" stroke-width="5" fill="none" />`,
    ellipse: `<ellipse cx="250" cy="200" rx="160" ry="90" stroke="#787878" stroke-width="5" fill="none" />`,
    polygon: `<polygon points="250,90 190,278 340,158 160,158 310,278" stroke="#787878" stroke-width="5" fill="none" />`,
    polyline: `<polyline points="200,140 240,140 240,180 280,180 280,220 320,220 320,260" stroke="#787878" stroke-width="5" fill="none"/>`,
    line: `<line x1="100" y1="200" x2="400" y2="200" stroke="#787878" stroke-width="5" fill="none" />`,
    path: `<path d="M150 0 L75 200 L225 200 Z" stroke="#787878" stroke-width="5" fill="none"/>`,
};
